<template>
  <div class="free-tool-banner">
    <span class="free-tool-banner__text">
      {{ $t("message.competitionComparison.freeToolBanner.textBefore") }}
      <strong>{{
        $t("message.competitionComparison.freeToolBanner.limit")
      }}</strong
      >.
      {{ $t("message.competitionComparison.freeToolBanner.textAfter") }}
    </span>
    <a :href="signupUrl" class="free-tool-banner__cta" target="_blank">
      {{ $t("message.competitionComparison.freeToolBanner.cta") }}
    </a>
  </div>
</template>

<script>
export default {
  name: "FreeToolBanner",
  data: () => ({
    signupUrl:
      "https://app.localzen.com/session/sign-up?access=approved&is_free_trial=true&plan=standard&locations=20&payment_cycle=monthly&price_list=LxTzxLRu8hGk&lang=en&utm_source=website&utm_medium=topbar&utm_campaign=topbar_cta&_gl=1*1yzn3uv*_gcl_aw*R0NMLjE3NDIyMTUyNjAuRUFJYUlRb2JDaE1JaDgtLTY1Q1JqQU1WN3dtaUF4MEpXREF2RUFFWUFTQUFFZ0pKbnZEX0J3RQ..*_gcl_au*MjIzNzkxNzY5LjE3MzYzNDIzMzM.*_ga*MTQwNDc4MjE4LjE3MTkyMzUzNjc.*_ga_98EZ0KNBW3*MTc0Mjk5NDczNS43MzQuMS4xNzQyOTk1NDI5LjU5LjAuMA.."
  })
};
</script>

<style lang="scss" scoped>
.free-tool-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: #eaf29d;
  padding: $spacing $spacing * 3;
  font-size: 14px;
  color: $grey-darker;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: $spacing * 1.5;
  flex-wrap: wrap;

  &__text {
    strong {
      font-weight: 700;
    }
  }

  @media (max-width: 768px) {
    text-align: center;
  }

  &__cta {
    display: inline-block;
    background-color: #ffffff;
    color: $grey-darker;
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
    border: 1px solid darken(#eaf29d, 15%);
    border-radius: 100px;
    padding: 4px $spacing * 2;
    white-space: nowrap;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: darken(#ffffff, 5%);
    }
  }
}
</style>
